import { FC, MouseEventHandler } from 'react';
import {
  Badge,
  Box,
  BoxProps,
  Button,
  Flex,
  keyframes,
  Text,
  VStack
} from '@chakra-ui/react';
import MintBall from './MintBall';
import GradientBackground from 'components/shared/GradientBackground';

type Props = {
  type: 'basic' | 'pro' | 'platinum';
  isPopular?: boolean;
  description: string;
  requirement: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  benefits: Array<string>;
};

const MintingCard: FC<Props> = ({
  type,
  isPopular,
  benefits,
  description,
  requirement,
  onClick
}) => {
  return (
    <GradientBackground
      visible={isPopular}
      borderRadius='2xl'
      height='100%'
      _hover={{
        animation: `${Press} infinite 2s linear`
      }}
    >
      <Flex
        flexDir='column'
        borderRadius='2xl'
        bg='gray.800'
        height='100%'
        position='relative'
      >
        <VStack flexGrow={1} alignItems='flex-start' p={[6, 7]}>
          <VStack justifyContent='left' alignItems='flex-start' mb={3.5}>
            <Flex alignItems='center'>
              <MintBall type={type} />
              <Flex flexDirection='column' ml={3} mb={0}>
                <Text fontSize='18px' fontWeight='600'>
                  {type.toUpperCase()}{' '}
                  {isPopular && (
                    <Badge ml={1} colorScheme='purple'>
                      Popular
                    </Badge>
                  )}
                </Text>
                <Text fontSize='14px' color='whiteAlpha.400' m='0'>
                  {description}
                </Text>
              </Flex>
            </Flex>
          </VStack>
          <VStack alignItems='flex-start' pl={3}>
            {benefits.map((item) => {
              return (
                <Flex key={item + type} alignItems='center'>
                  <BasicBall bg='green.500' mr={'25px'} minW='18px' minH='18px' w='18px' h='18px' />
                  <Text fontSize='14x' color='whiteAlpha.600'>
                    {item}
                  </Text>
                </Flex>
              );
            })}
          </VStack>
        </VStack>
        <VStack justifyContent='left' alignItems='center' width='100%'>
          <Flex alignItems='center' color='gray.300' width='100%'>
            <Box height={'1px'} flex={1} bg={'gray.300'} width='100px' />
            <Text mx={3} fontSize='14px'>
              Requirement
            </Text>
            <Box height={'1px'} flex={1} bg={'gray.300'} width='100%' />
          </Flex>
          <Flex
            p={6}
            flexDirection='column'
            pt={0}
            width='100%'
            alignItems='center'
          >
            <Text fontSize='24px' fontWeight='bold' mb={5} mt={'5px'}>
              {requirement}
            </Text>
            <Button isFullWidth onClick={onClick}>
              Select
            </Button>
          </Flex>
        </VStack>
      </Flex>
    </GradientBackground>
  );
};

const Press = keyframes`
     50% {
        transform: translateY(2px);
    }

    100% {
        transform: translateY(0);
    }
`;

const BasicBall = (props: BoxProps) => {
  return (
    <Box
      w='43px'
      h='43px'
      minW='43px'
      minH='43px'
      borderRadius='3xl'
      bgGradient='linear(to-tr,  #E6E6E6, #757575)'
      {...props}
    />
  );
};

export default MintingCard;
